<template>
  <span v-if="code" class="disp" :class="tone" :title="label">
    <AppIcon :name="icon" :size="13" />
    <span class="dlabel">{{ label }}</span>
  </span>
  <span v-else class="dispDash">——</span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import AppIcon from '../../../components/AppIcon.vue'
import { dispositionDisplayLabel, dispositionIcon, dispositionTone } from './dialerDispositions'

const props = defineProps<{ code: string | null | undefined }>()

const label = computed(() => dispositionDisplayLabel(props.code))
const icon = computed(() => dispositionIcon(props.code))
const tone = computed(() => dispositionTone(props.code))
</script>

<style scoped>
.disp {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px 3px 8px;
  border-radius: var(--radius-full, 999px);
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  /* Without these the pill keeps its intrinsic width. */
  min-width: 0;
  max-width: 100%;
  /* Neutral default — a visible warm-gray chip (not the near-invisible status-neutral). */
  background: var(--color-bg-subtle, #ece7de);
  color: var(--color-text-secondary, #525252);
}
.disp :deep(svg) {
  flex: none;
}
.dlabel {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.disp.connected {
  background: var(--status-success-bg);
  color: var(--status-success-text);
}
.disp.callback {
  background: rgba(59, 130, 246, 0.14);
  color: #1e40af;
}
html[data-theme='dark'] .disp.callback {
  background: rgba(59, 130, 246, 0.16);
  color: #93c5fd;
}
.disp.voicemail {
  background: var(--status-warning-bg);
  color: var(--status-warning-text);
}
.disp.danger {
  background: var(--status-danger-bg);
  color: var(--status-danger-text);
}
.disp.neutral {
  background: var(--color-bg-subtle, #ece7de);
  color: var(--color-text-secondary, #525252);
}
.dispDash {
  color: var(--color-text-tertiary, #a3a3a3);
}
</style>
